import { memoSanitize } from '@axa-asia/emma-safely-set-inner-html';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { BannerConfig } from '../../../../modules/myPrivileges/types';
import { getToken } from '../../../../selectors/authSelectors';
import { select } from '../../../../stores';
import { getValidToken, isApp } from '../../../../utils';
import {
  getGaPagePath,
  handleGaError,
} from '../../../../utils/generalGaEventAnalytics';
import './styles.scss';

export interface MyPrivilegesBannerProps {
  banner: BannerConfig;
}

export interface MyPrivilegesBannerState {
  descOverflow?: boolean;
  isShowEllipsis?: boolean;
  isClickedShowMoreDesc?: boolean;
  descText: string;
}

export class MyPrivilegesBanner extends Component<
  MyPrivilegesBannerProps,
  MyPrivilegesBannerState
> {
  constructor(props: any = {}) {
    super(props);
    this.state = {
      descOverflow: false,
      isClickedShowMoreDesc: false,
      isShowEllipsis: false,
      descText: '',
    };
  }

  componentDidMount() {
    this.setState({ descText: this.props.banner.desc });
    const offsetWidth = document.body.offsetWidth;
    if (offsetWidth < 769) {
      this.handleResize(offsetWidth, 'init');
    }
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize.bind(this));
  }

  handleResize(e: any, ope = '') {
    const innerWidth = ope === 'init' ? e : e.target.innerWidth;
    const descText = this.props.banner.desc;
    if (innerWidth < 769) {
      if (descText.length > this.props.banner.descCharLength) {
        this.setState({
          descOverflow: true,
          isShowEllipsis: true,
          descText: descText.substring(0, this.props.banner.descCharLength),
        });
      } else {
        this.setState({
          descOverflow: false,
          isShowEllipsis: false,
          descText: descText,
        });
      }
    } else {
      this.setState({
        descOverflow: false,
        isClickedShowMoreDesc: false,
        isShowEllipsis: false,
        descText: descText,
      });
    }
  }

  showMoreDesc(isShowMoreDesc: boolean) {
    const descText = this.props.banner.desc;
    if (isShowMoreDesc) {
      if (descText.length > 450) {
        this.setState({
          isClickedShowMoreDesc: true,
          isShowEllipsis: true,
          descText: descText.substring(0, 450),
        });
      } else {
        this.setState({
          isClickedShowMoreDesc: true,
          isShowEllipsis: false,
          descText: descText,
        });
      }
    } else {
      if (descText.length > this.props.banner.descCharLength) {
        this.setState({
          isClickedShowMoreDesc: false,
          isShowEllipsis: true,
          descText: descText.substring(0, this.props.banner.descCharLength),
        });
      } else {
        this.setState({
          isClickedShowMoreDesc: false,
          isShowEllipsis: false,
          descText: descText,
        });
      }
    }
  }

  onClickToGatc() {
    const { knowMore } = this.props.banner;
    const tcWindow: any = window;
    try {
      const token = select(getToken);
      const aToken = getValidToken(token);
      tcWindow.dataLayer.push({
        event: 'servicesOpen',
        serviceButton: knowMore ? knowMore.label : '',
        serviceName: 'My Privileges',
        serviceId: 'knowmoreaboutbetterme',
        page: getGaPagePath(),
        userId: aToken,
      });

      // HKEMMA-100917 - GA3 Decommission - Remove GA3
      // if (!isApp()) {
      //   tcWindow.tC.event.servicesOpen(tcWindow, {
      //     serviceButton: knowMore ? knowMore.label : '',
      //     serviceName: 'My Privileges',
      //     serviceId: 'knowmoreaboutbetterme',
      //     page: getGaPagePath(),
      //   });
      // }
    } catch (e) {
      handleGaError(e);
    }
  }

  render() {
    const {
      largeViewPointImage,
      smallViewPointImage,
      title,
      subtitle,
      desc,
      descCharLength,
      descMore,
      descLess,
      knowMore,
    } = this.props.banner;

    return (
      <div className="banner-container">
        <div className="myprivileges-banner">
          <div className="myprivileges-banner__top-container">
            <div className="myprivileges-banner__image-container">
              {largeViewPointImage && (
                <div
                  className="myprivileges-banner__large-viewpoint-image"
                  style={{ backgroundImage: `url(${largeViewPointImage})` }}
                ></div>
              )}
              {smallViewPointImage && (
                <div
                  className="myprivileges-banner__small-viewpoint-image"
                  style={{ backgroundImage: `url(${smallViewPointImage})` }}
                ></div>
              )}
            </div>
          </div>
          <div className="myprivileges-banner__bottom-container">
            {subtitle && (
              <div className="myprivileges-banner__subtitle">{subtitle}</div>
            )}
            {desc && (
              <div className="myprivileges-banner__desc-container">
                {descCharLength !== 0 ? (
                  <div>
                    <span
                      className="myprivileges-banner__desc"
                      dangerouslySetInnerHTML={{
                        __html: memoSanitize(this.state.descText),
                      }}
                    ></span>
                    {this.state.isShowEllipsis && (
                      <span className="myprivileges-banner__desc">...</span>
                    )}
                    {descMore &&
                      this.state.descOverflow &&
                      !this.state.isClickedShowMoreDesc && (
                        <span
                          className="myprivileges-banner__desc-more"
                          onClick={() => this.showMoreDesc(true)}
                          data-enable-ga
                          data-ga-type="button"
                        >
                          {descMore}
                        </span>
                      )}
                    {descMore &&
                      this.state.descOverflow &&
                      this.state.isClickedShowMoreDesc && (
                        <span
                          className="myprivileges-banner__desc-more"
                          onClick={() => this.showMoreDesc(false)}
                          data-enable-ga
                          data-ga-type="button"
                        >
                          {descLess}
                        </span>
                      )}
                  </div>
                ) : (
                  <div>
                    <span
                      className="myprivileges-banner__desc"
                      dangerouslySetInnerHTML={{
                        __html: memoSanitize(desc || ''),
                      }}
                    ></span>
                  </div>
                )}
              </div>
            )}
            {knowMore && !(JSON.stringify(knowMore) === '{}') && (
              <div>
                {knowMore && (
                  <a
                    className="myprivileges-banner__know-more-btn"
                    onClick={() => this.onClickToGatc()}
                    target="_blank"
                    href={knowMore.deepLink}
                    data-enable-ga
                    data-ga-type="button"
                    rel="noreferrer"
                  >
                    {knowMore.label}
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    return {};
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  MyPrivilegesBanner.mapStateToProps,
  MyPrivilegesBanner.mapDispatchToProps,
)(MyPrivilegesBanner);
